import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-stepper-page-ui',
    templateUrl: './bb-stepper-page-ui.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbStepperPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
